import {Component, Inject, OnInit} from '@angular/core';
import {MatDialog, MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {OrganizationService} from "../../../../../service-data/organization.service";
import {Organization} from "../../../../../../model/Organization";
import {ProjectFolders} from "../../../../../../model/supporting/ProjectFolders";
import {Util} from "../../../../../util/Util";
import {ProjectService} from "../../../../../service-data/project.service";
import {debounceTime} from "rxjs/operators";
import {LanguagePipe} from "../../../../../pipe/language.pipe";

@Component({
  selector: 'app-move-project-folder',
  templateUrl: './move-project-folder.component.html',
  styleUrls: ['./move-project-folder.component.css']
})
export class MoveProjectFolderComponent implements OnInit {
  public breakpoint: number; // Breakpoint observer code
  public newFolderName: string;
  public changeForm: FormGroup;
  wasFormChanged = false;
  organization: Organization;
  selectedFolder: string;
  projectFolders: ProjectFolders;
  /** Set when ProjectFolders refuses the move; keeps the dialog open. */
  errorMessage: string = '';

  protected readonly Util = Util;

  constructor(private formBuilder: FormBuilder, public dialog: MatDialog, public organizationService: OrganizationService, private projectService: ProjectService,  @Inject(MAT_DIALOG_DATA) data, private dialogRef: MatDialogRef<MoveProjectFolderComponent>) {
    // Get data passed in
    if ( data.organization ) {
      this.organization = data.organization;
      this.projectFolders = this.organization.getProjectFolders();
      this.selectedFolder = data.selectedFolder;
      this.newFolderName = '';
    }
  }

  public ngOnInit(): void {
    const dirNameRegex = /^(?!(?:CON|PRN|AUX|NUL|COM[1-9]|LPT[1-9])(?:\.[^.]*)?$)[^<>:"/\\|?*\x00-\x1F]*[^<>:"/\\|?*\x00-\x1F .]$/;
    this.changeForm = this.formBuilder.group({
      newFolderName: [this.newFolderName, [Validators.required, Validators.pattern(dirNameRegex)]]
    });
    this.breakpoint = window.innerWidth <= 600 ? 1 : 2; // Breakpoint observer code
    this.changeForm.get('newFolderName').valueChanges.pipe(debounceTime(300)) // Wait 300ms after the last keystroke
      .subscribe(() => this.handleSelection(this.changeForm.get('newFolderName').value));
  }

  public onChange(): void {
    this.errorMessage = '';
    if ( this.projectFolders ) {
      try {
        const currentLeafFolderName = Util.getLastItem(this.selectedFolder, '/');
        // Throws if the destination already holds a folder of this name, or if
        // the destination is inside the folder being moved. Both used to
        // succeed: the first overwrote the destination and discarded its
        // subtree, the second built a reference cycle and made the whole branch
        // vanish from the tree.
        this.projectFolders.moveFolder(this.selectedFolder, this.newFolderName, currentLeafFolderName);
        this.organization.setProjectFolders(this.projectFolders);
        this.organizationService.updateItem(this.organization).subscribe( x => {
          console.log(`Move Folder completed in OrganizationService ${this.selectedFolder}`);
        });
        this.projectService.moveProjectsInFolder(this.selectedFolder, this.newFolderName  + '/' + currentLeafFolderName).subscribe( response => {
          console.log(`Move Folder completed in ProjectService ${this.selectedFolder}`);
        });
      } catch ( e ) {
        // Keep the dialog open: closing it implied the move had happened.
        // NOTE: the tree write and the Project write above are still two
        // separate un-sequenced calls (PF-8). Throwing here at least keeps the
        // failure before either of them, so a refused move writes nothing.
        console.log(`Move Folder not completed ${this.selectedFolder}`, e);
        this.errorMessage = LanguagePipe.get('A folder with that name already exists here.', 'compressSpaces');
        return;
      }
    }
    this.markAsDirty(this.changeForm);
    this.dialogRef.close({});
  }

  // tslint:disable-next-line:no-any
  public onResize(event: any): void {
    this.breakpoint = event.target.innerWidth <= 600 ? 1 : 2;
  }

  private markAsDirty(group: FormGroup): void {
    group.markAsDirty();
    // tslint:disable-next-line:forin
    for (const i in group.controls) {
      group.controls[i].markAsDirty();
    }
  }

  formChanged() {
    this.wasFormChanged = true;
  }

  handleSelection(name: string) {
    this.newFolderName = name;
    console.log('User selected:', name);
  }

}
